export default __webpack_public_path__ + "static/media/thumbpics4.04eb1044.jpg";